var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-icon-badge flex flex-center",class:`header-icon-badge--${_vm.value.toString().length}`},[_c('span',[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.iconDescription))])])
}
var staticRenderFns = []

export { render, staticRenderFns }